const defaultState = {
  isSideNavOpen: false,
  isSideNavHover: false,
};
export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case 'SET_SIDE_NAV_MENU_STATUS':
      return { ...state, isSideNavOpen: payload };
    case 'SET_SIDE_NAV_OPEN':
      return { ...state, isSideNavHover: payload };
    default:
      return state;
  }
};
